import { useMutation } from "react-query";
import http from "infra/http";
import { AxiosResponse } from "axios";
import { UnidadeForm } from "./typings/unidade";

function useSaveUnidade(id?: string, tenantId?: string) {
  return useMutation(
    [`/v1/unidades/${id ?? ""}`, id],
    (data: UnidadeForm): Promise<AxiosResponse<{ id: string }>> => {
      for (const key of Object.keys(data.endereco ?? {})) {
        const e = (data.endereco as any)[key];

        if (e === undefined || e === "") {
          delete (data.endereco as any)[key];
        }
      }

      if (!Object.keys(data.endereco ?? {}).length) {
        data.endereco = undefined;
      }

      const headers: any = {};

      if (tenantId) {
        headers.tenant = tenantId;
      }

      if (!id) {
        return http.post(`/v1/unidades`, data, {
          headers,
        });
      }

      return http.put(`/v1/unidades/${id}`, data, {
        headers,
      });
    },
    { retry: false }
  );
}

export default useSaveUnidade;
